webpackJsonp([38262206689887],{

/***/ "./src/components/Faq/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	__webpack_require__("./src/components/Faq/styles.sass");
	
	var _translations = __webpack_require__("./translations/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //---------	Global imports
	
	
	//---------	Plugins
	
	
	//---------	Styles
	
	
	//---------	Translations
	
	
	var Faq = function (_React$Component) {
	  _inherits(Faq, _React$Component);
	
	  //---------	Constructor
	  function Faq(props) {
	    _classCallCheck(this, Faq);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      results: []
	    };
	
	    _this.filterSearchTerm = _this.filterSearchTerm.bind(_this);
	    _this.populateResults = _this.populateResults.bind(_this);
	    return _this;
	  }
	
	  //---------	React functions
	
	
	  Faq.prototype.componentDidMount = function componentDidMount() {
	    this.filterSearchTerm();
	  };
	
	  //---------	Custom functions
	
	
	  Faq.prototype.toggleAnswer = function toggleAnswer(e) {
	    var question = e.target;
	    var answer = question.nextElementSibling;
	
	    $(question).toggleClass('state-active');
	    $(answer).slideToggle(150);
	  };
	
	  Faq.prototype.filterSearchTerm = function filterSearchTerm(e) {
	    var searchTerm = e ? e.target.value.toLowerCase() : '';
	    var data = (0, _lodash.filter)(_translations.T.faq.QA, function (qa) {
	      return (0, _lodash.includes)(qa.q.toLowerCase(), searchTerm);
	    });
	
	    this.populateResults(data);
	  };
	
	  Faq.prototype.populateResults = function populateResults(data) {
	    var _this2 = this;
	
	    var results = [];
	
	    if (data.length > 0) {
	      (0, _lodash.forEach)(data, function (el, key) {
	        results.push(_react2.default.createElement(
	          'div',
	          { className: 'CalipsyFAQ-result', key: key },
	          _react2.default.createElement(
	            'h4',
	            { className: 'CalipsyFAQ-q',
	              onClick: _this2.toggleAnswer },
	            el.q
	          ),
	          _react2.default.createElement('div', { className: 'CalipsyFAQ-a', dangerouslySetInnerHTML: { __html: el.a } })
	        ));
	      });
	    } else {
	      results.push(_react2.default.createElement(
	        'div',
	        { className: 'CalipsyFAQ-result state-fixed', key: 'contactus' },
	        _react2.default.createElement(
	          'h4',
	          { className: 'CalipsyFAQ-q' },
	          'We can\'t find any question related to your phrase :('
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'CalipsyFAQ-a', style: { display: 'block' } },
	          'We are more than happy to help you with any question related to our products or the website. You can contact us directly at ',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:hello@calipsy.com' },
	            'hello@calipsy.com'
	          )
	        )
	      ));
	    }
	
	    this.setState({ results: results });
	  };
	
	  //---------	Render
	
	
	  Faq.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'CalipsyFAQ' },
	      _react2.default.createElement(
	        'div',
	        { className: 'CalipsyContainer' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _translations.T.faq.title
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          _translations.T.faq.subtitle
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'CalipsyFAQ-filterBy' },
	          _react2.default.createElement('input', { type: 'text', onKeyUp: this.filterSearchTerm, placeholder: _translations.T.faq.placeholder }),
	          _react2.default.createElement(
	            'button',
	            { className: 'CalipsyButton CalipsyButton-blue' },
	            _translations.T.global.search
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'CalipsyFAQ-results' },
	          _react2.default.createElement(
	            'div',
	            null,
	            this.state.results
	          )
	        )
	      )
	    );
	  };
	
	  return Faq;
	}(_react2.default.Component);
	
	exports.default = Faq;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/Faq/styles.sass":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"D:/projekty/Calipsy/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"D:/projekty/Calipsy/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"D:/projekty/Calipsy/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"D:/projekty/Calipsy/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"D:/projekty/Calipsy/node_modules/babel-preset-stage-0/lib/index.js\",\"D:/projekty/Calipsy/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/faq.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Commons = __webpack_require__("./src/Components/Shared/Commons.js");
	
	var _translations = __webpack_require__("./translations/index.js");
	
	var _Banner = __webpack_require__("./src/components/Banner/index.js");
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Faq = __webpack_require__("./src/components/Faq/index.js");
	
	var _Faq2 = _interopRequireDefault(_Faq);
	
	var _Newsletter = __webpack_require__("./src/components/Newsletter/index.js");
	
	var _Newsletter2 = _interopRequireDefault(_Newsletter);
	
	var _index = __webpack_require__("./src/components/SEO/index.js");
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //---------	Global imports
	
	
	//---------  Plugins
	
	
	//---------	Translations
	
	
	//---------	Components
	
	
	var FaqTemplate = function (_React$Component) {
	  _inherits(FaqTemplate, _React$Component);
	
	  //---------	Constructor
	  function FaqTemplate() {
	    _classCallCheck(this, FaqTemplate);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      loading: true
	    };
	    return _this;
	  }
	
	  //---------	React functions
	
	
	  FaqTemplate.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      return _this2.setState({ loading: false });
	    }, 300);
	    setTimeout(function () {
	      return (0, _Commons.onTemplateLoad)();
	    });
	  };
	
	  FaqTemplate.prototype.render = function render() {
	    var data = this.props.data.markdownRemark.frontmatter;
	    var seo = {
	      title: _translations.T.SEO.title.faq + ' - ' + data.title + ' | Calipsy'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: this.state.loading ? 'CalipsyWrapper CalipsyWrapper-loading' : 'CalipsyWrapper' },
	      _react2.default.createElement(_index2.default, seo),
	      _react2.default.createElement('div', { className: 'CalipsySpinner' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'CalipsyWrapper-container' },
	        _react2.default.createElement(_Banner2.default, { data: data.banner }),
	        _react2.default.createElement(_Faq2.default, null),
	        _react2.default.createElement(_Newsletter2.default, null)
	      )
	    );
	  };
	
	  return FaqTemplate;
	}(_react2.default.Component);
	
	exports.default = FaqTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-faq-js-00dc3b3a97cbf02f7c0d.js